/* Bellencore — panier, vague 37.
   Passage au Rituel complet depuis le panier (tiroir et page /cart), en une interaction.

   Source de vérité : l'offre Kaching existante. Ce script ne calcule aucun prix et ne crée aucune remise.
   Il rejoue la structure de lignes que Kaching écrit lui-même quand la cliente choisit « Rituel complet »
   sur la fiche produit (ligne Ondélia marquée bundle + ligne Gel « bundleProduct »), en conservant la
   version de l'offre, la variante de test A/B et l'identifiant de session Kaching portés par la ligne.
   Puis il CONTRÔLE le prix réellement appliqué par Shopify : si le Gel n'est pas facturé au supplément
   annoncé, le panier est remis dans son état d'origine et la cliente est renvoyée vers la fiche produit. */
(function () {
  if (window.__bcCartLoaded) return;
  window.__bcCartLoaded = true;

  var HEADERS = { 'Content-Type': 'application/json', Accept: 'application/json' };

  function post(url, data) {
    return fetch(url, { method: 'POST', headers: HEADERS, body: JSON.stringify(data) }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    });
  }

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json();
    });
  }

  function parse(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  function parseKaching(item) {
    try {
      return JSON.parse((item.properties || {}).__kaching_bundles || '{}');
    } catch (_) {
      return {};
    }
  }

  function withKaching(item, value) {
    var props = Object.assign({}, item.properties || {});
    props.__kaching_bundles = JSON.stringify(value);
    return props;
  }

  /* Re-rend le tiroir et, sur /cart, les deux sections de la page — sans rechargement. */
  function refresh(cart) {
    var jobs = [];
    var empty = cart.item_count === 0;
    var drawer = document.querySelector('cart-drawer');
    var pageItems = document.getElementById('main-cart-items');
    var pageFooter = document.getElementById('main-cart-footer');

    if (drawer) {
      jobs.push(
        fetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble')
          .then(function (r) { return r.json(); })
          .then(function (s) {
            var source = parse(s['cart-drawer'], '.drawer__inner');
            var target = drawer.querySelector('.drawer__inner');
            if (source && target) target.innerHTML = source.innerHTML;
            drawer.classList.toggle('is-empty', empty);
            var bubble = document.getElementById('cart-icon-bubble');
            var bubbleSource = parse(s['cart-icon-bubble'], '.shopify-section');
            if (bubble && bubbleSource) bubble.innerHTML = bubbleSource.innerHTML;
          })
      );
    }

    if (pageItems && pageFooter) {
      var ids = [pageItems.dataset.id, pageFooter.dataset.id];
      jobs.push(
        fetch(window.location.pathname + '?sections=' + ids.join(','))
          .then(function (r) { return r.json(); })
          .then(function (s) {
            [[pageItems, ids[0]], [pageFooter, ids[1]]].forEach(function (pair) {
              var source = parse(s[pair[1]], '.js-contents');
              var target = pair[0].querySelector('.js-contents');
              if (source && target) target.innerHTML = source.innerHTML;
            });
            var host = pageItems.closest('cart-items');
            if (host) host.classList.toggle('is-empty', empty);
            pageFooter.classList.toggle('is-empty', empty);
          })
      );
    }

    return Promise.all(jobs);
  }

  function announce() {
    document.querySelectorAll('[data-bc-ok]').forEach(function (el) {
      el.classList.add('is-new');
    });
    var drawer = document.querySelector('cart-drawer');
    var scope = drawer && drawer.classList.contains('active') ? drawer : document.getElementById('main-cart-items');
    var ok = scope && scope.querySelector('[data-bc-ok]');
    if (ok) setTimeout(function () { ok.focus(); }, 60);
    var live = document.getElementById('CartDrawer-LiveRegionText') || document.getElementById('cart-live-region-text');
    if (live) live.textContent = 'Rituel complet sélectionné : Ondélia et Gel Modelant Corps.';
  }

  async function upgrade(button) {
    var gelVariant = Number(button.dataset.gel);
    var delta = Number(button.dataset.delta);
    var fallback = button.dataset.fallback || '/products/ondelia';
    var original = null;
    var addedGel = false;

    try {
      var cart = await getCart();
      var ond = cart.items.filter(function (i) { return i.handle === 'ondelia'; });
      var gels = cart.items.filter(function (i) { return i.handle === 'gel-modelant-corps'; });
      if (ond.length !== 1 || ond[0].quantity !== 1) throw new Error('ondelia');
      if (gels.length > 1 || (gels[0] && (gels[0].quantity !== 1 || gels[0].variant_id !== gelVariant))) throw new Error('gel');

      var k = parseKaching(ond[0]);
      /* Sans marquage Kaching sur la ligne (ajout hors sélecteur), on ne devine rien : la fiche produit fait foi. */
      if (!k.deal || !k.v) throw new Error('kaching');

      original = { ond: ond[0], gel: gels[0] || null };
      var bundleId = 'bc' + Date.now().toString(36).slice(-4);

      var main = { deal: k.deal, pp: k.pp || ond[0].product_id, main: true, v: k.v, id: bundleId, bar: button.dataset.bar };
      var side = { id: bundleId, deal: k.deal, bar: button.dataset.bar, v: k.v };
      if (k.abid) { main.abid = k.abid; main.ab = k.ab; side.abid = k.abid; side.ab = k.ab; }
      side.bundleProduct = button.dataset.bundleProduct;

      await post('/cart/change.js', { id: ond[0].key, quantity: 1, properties: withKaching(ond[0], main) });
      if (gels[0]) {
        await post('/cart/change.js', { id: gels[0].key, quantity: 1, properties: withKaching(gels[0], side) });
      } else {
        await post('/cart/add.js', { items: [{ id: gelVariant, quantity: 1, properties: { __kaching_bundles: JSON.stringify(side) } }] });
        addedGel = true;
      }

      /* Contrôle du prix réel : le Gel doit être facturé exactement au supplément affiché. */
      cart = await getCart();
      var gel = cart.items.find(function (i) { return i.handle === 'gel-modelant-corps'; });
      var ondNow = cart.items.find(function (i) { return i.handle === 'ondelia'; });
      if (!gel || !ondNow || gel.quantity !== 1 || ondNow.quantity !== 1 || gel.final_line_price !== delta) {
        throw new Error('price');
      }

      await refresh(cart);
      announce();
    } catch (error) {
      /* Retour à l'état d'origine, puis fiche produit (sélecteur Kaching natif). */
      try {
        if (original) {
          var now = await getCart();
          var g = now.items.find(function (i) { return i.handle === 'gel-modelant-corps'; });
          var o = now.items.find(function (i) { return i.handle === 'ondelia'; });
          if (g && addedGel) await post('/cart/change.js', { id: g.key, quantity: 0 });
          else if (g && original.gel) await post('/cart/change.js', { id: g.key, quantity: 1, properties: original.gel.properties || {} });
          if (o) await post('/cart/change.js', { id: o.key, quantity: 1, properties: original.ond.properties || {} });
        }
      } catch (_) {}
      window.location.href = fallback;
    }
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-bc-upgrade]');
    if (!button || button.disabled) return;
    event.preventDefault();
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.textContent = 'Un instant…';
    upgrade(button);
  });
})();
